export default "__VITE_ASSET__Dat4D3ik__"